module.exports = __webpack_public_path__ + "img/surgicalScrubs.845a7a77.png";